// extracted by mini-css-extract-plugin
export default {"formCntrl":"Password_formCntrl__-pzub","blackText":"Password_blackText__xBmT7"};